import i18n from 'i18next';
import Backend from "i18next-http-backend";
import { initReactI18next } from 'react-i18next';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

const languages = {
	ENGLISH: "en",
	FRENCH: "fr",
	GERMAN: "de",
	SPANISH: "es",
	JAPANESE: "ja",
    Netherlands: 'nl',
    Italy: 'it'
};

const currentLan = cookies.get('language') || window.navigator.language;

const backendOpts = {
    loadPath: `i18n/{{ns}}-{{lng}}.json`
};

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        debug: process.env.NODE_ENV !== 'production',
        supportedLngs: Object.values(languages),
        fallbackLng: 'en',
        backend: backendOpts,
        lng: currentLan,
        interpolation: {
            escapeValue: false
        }   
    });